import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const postUsersMeV2OrganisationsCurrentByTypeResourcesSelector =
  cloudChiprApi.endpoints.postUsersMeV2OrganisationsCurrentByTypeResources
    .select;
